import { PlusIcon } from "@otomoro/components/icons/Plus";
import { Button } from "@otomoro/components/shared/Button";

export type LoadMoreProps = {
	articles: any[];
	nextArticles: any[];
	onClick: () => void;
};

export const LoadMore = ({ nextArticles, onClick }: LoadMoreProps) => {

	if (!nextArticles || nextArticles.length <= 0) return

	return (
			<Button arrow={false} className="w-fit mt-3 lg:mt-4 mx-auto col-span-full" onClick={onClick}>
				<span className="inline-flex items-center">
					<span className="hidden md:block">
						Load more articles
					</span>
					<span className="md:hidden">
						Load more
					</span>
					<PlusIcon className="w-1 h-1 ml-1"/>
				</span>
			</Button>
	)
};
